module.exports = __webpack_public_path__ + "static/us-026a8970e863d32e6fb829b2a7e51c0e.svg";